import BaseService from "../BaseService";
import _ from "lodash";

class ProductService extends BaseService {
    list = async ({ info } = {}, fields) => {
        const normalizedFields = Array.isArray(fields)
            ? _.uniq(fields.map((x) => String(x || "").trim()).filter(Boolean))
            : [];

        const requestConfig = normalizedFields.length > 0
            ? { params: { fields: JSON.stringify(normalizedFields) } }
            : undefined;

        var data = await this._api.post("/store/product/list", { info }, requestConfig);
        return data;
    };

    get = async (id) => {
        var data = await this._api.get(`/store/product/get`, { params: { id: id } });
        return data;
    };


    getRelated = async (id) => {
        var data = await this.cache.get("reated_product");
        if (data) {
            return data;
        }
        var data = await this._api.post(`/store/product/get_related`, { params: { id: id } });
        await this.cache.set("reated_product", data, 100000)
        return data;
    };




}
export default ProductService;
